import { Settings } from 'lucide-react';
import { Input, ToggleOptionGroup, ToggleOptionGroupItem, DefaultTooltip } from 'twyne-new.ui';

import { useResponsive, useUtilities } from '@/modules/cms/views/post/components/builder/context';

import { useCraftProp } from '../utils';

export default function ZindexProperty() {
  const { device } = useResponsive()
  const { selectedUtilities } = useUtilities()

  return <Zindex key={device + selectedUtilities} />
}

function Zindex() {
  const { value: zindex, setValue: setZindex } = useCraftProp('zindex')

  return <>
    <div className='flex gap-1'>
      <Input
        value={zindex}
        onChange={e => setZindex(e.target.value.replace(/[.]/g, ''))}
        type={zindex === 'auto' ? 'text' : 'number'}
        variant='accent'
        disabled={zindex === 'auto'}
      />
      <ToggleOptionGroup size='lg' value={zindex === 'auto' ? 'auto' : ''} type='single' onValueChange={value => setZindex(value === 'auto' ? 'auto' : '')}>
        <ToggleOptionGroupItem value='auto'>
          <DefaultTooltip content='Auto' triggerProps={{ className: 'w-full flex justify-center' }}>
            <Settings size='16' />
          </DefaultTooltip>
        </ToggleOptionGroupItem>
      </ToggleOptionGroup>
    </div>
  </>
}
